module.exports = __webpack_public_path__ + "img/icon-currency.843baf52.svg";